var swiper = new Swiper(".slider-swiper", {
  loop: true,
  slidesPerView: 'auto',
  centeredSlides: true,
  effect: "coverflow",
  navigation: {
    nextEl: ".button-next",
    prevEl: ".button-prev",
  },
  coverflowEffect: {
    rotate: 20,
    stretch: 0,
    depth: 5,
    modifier: 1,
    slideShadows: false,
  },
});


var photoTumb = new Swiper(".swiper-thumb-photo", {
  spaceBetween: 20,
  slidesPerView: 3,
  freeMode: true,
  watchSlidesProgress: true,
  navigation: {
    nextEl: ".button-next",
    prevEl: ".button-prev",
  },
});
var photos = new Swiper(".swiper-photo", {
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  thumbs: {
    swiper: photoTumb,
  },
});

document.addEventListener('DOMContentLoaded', function() {
  var videoSlide = new Swiper(".swiper-video", {
    spaceBetween: 10,
    navigation: {
      nextEl: ".button-video-next",
      prevEl: ".button-video-prev",
    },
  });

  var players = document.querySelectorAll('.player');
  players.forEach(function(video){
    var player = new Plyr(video);

    videoSlide.on('slideChange', function(){
      player.pause();
    })
  })
})


$(document).ready(function() {
  $('#filterYear').select2({
    theme: 'filter-select',
    minimumResultsForSearch: Infinity
  });
  $('#filterMonth').select2({
    theme: 'filter-select',
    minimumResultsForSearch: Infinity
  });
  $('#filterIncidentType').select2({
    theme: 'filter-select',
    placeholder: 'สถานการณ์',
    minimumResultsForSearch: Infinity
  });
  $('#filterArea').select2({
    theme: 'filter-select-area',
    placeholder: 'พื้นที่',
    minimumResultsForSearch: Infinity
  });
  $('#statisticsyear').select2({
    theme: 'filter-select',
    placeholder: 'พื้นที่',
    minimumResultsForSearch: Infinity,
    width: '150px'
  });

  $('#select').select2({
    theme: 'filter-select-modal',
    placeholder: 'พื้นที่',
    minimumResultsForSearch: Infinity,
    width: '100%'
  });
});

$(document).ready(function() {
  $('.datepicker').pickadate({
    today: '',
    clear: 'Clear selection',
    close: 'Cancel'
  });

  $('.datetimepicker').pickatime();
});


// Get all elements with class "actual-btn"
const actualBtns = document.querySelectorAll('.actual-btn');

// Loop over each element and attach event listener
actualBtns.forEach((btn, index) => {
  const fileChosen = document.getElementById(`file-chosen${index + 1}`);

  btn.addEventListener('change', function(){
    fileChosen.textContent = this.files[0].name;
  });
});

const ctx = document.getElementById('myChart');

new Chart(ctx, {
  type: 'line',
  data: {
    labels: ['ม.ค', 'ก.พ', 'มี.ค', 'เม.ย', 'พ.ค', 'มิ.ย','ก.ค', 'ส.ค', 'ก.ย', 'ต.ค', 'พ.ย', 'ธ.ค'],
    datasets: [{
      label: 'จำนวนเหตุการณ์รายเดือน',
      data: [1, 1.8, 1.8, 0.6, 0.8, 1.0 ,1.2,1.4,1.6,1.8,2.0 , 1],
      backgroundColor: 'rgba(208, 125, 217, 0.5)',
      borderColor: '#ce49e4',
      borderWidth: 5,
      fill: true
    }]
  },
  options: {
    scales: {
      y: {
        beginAtZero: true
      }
    }
  }
});

const ctxs = document.getElementById('areaChart');

new Chart(ctxs, {
  type: 'bar',
  data: {
    labels: ['สนญ', 'กฟน.1', 'กฟน.2', 'กฟน.3', 'กฟฉ.1', 'กฟฉ.2','กฟฉ.3', 'กฟก.1', 'กฟก.2', 'กฟก.3', 'กฟต.1', 'กฟต.2', 'กฟต.3'],
    datasets: [{
      label: 'จำนวนเหตุการณ์แยกตามพื้นที่',
      data: [0, 0.2, 0.4, 0.6, 0.8, 1.0 ,1.2,1.4,1.6,1.8,2.0],
      backgroundColor: 'rgba(208, 125, 217, 0.5)',
      borderColor: '#ce49e4',
      borderWidth: 5,
    }]
  },
  options: {
    layout: {
      padding: 20
    },
    scales: {
      y: {
        beginAtZero: true,
      }
    },
    plugins: {
      legend: {
        labels: {
          font: {
            size: 14,
            family: `"Prompt", sans-serif`
          }
        }
      }
    }
  }
});

const ctxss = document.getElementById('catChart');

new Chart(ctxss, {
  type: 'bar',
  data: {
    labels: ['ภาพลักษณ์ PEA', 'ค่าไฟฟ้า', 'มาตราการภาครัฐ', 'ระบบไฟฟ้าขัดข้อง', 'อุบัติเหตุ และ ภัยพิบัติ', 'พลังงานทดแทน EV','อื้น ฯ'],
    datasets: [{
      label: 'จำนวนเหตุการณ์แยกตามประเด็นเนื้อหา',
      data: [0, 0.2, 0.4, 0.6, 0.8, 1.0 ,1.2,1.4,1.6,1.8,2.0],
      backgroundColor: 'rgba(208, 125, 217, 0.5)',
      borderColor: '#ce49e4',
      borderWidth: 5,
    }]
  },
  options: {
    layout: {
      padding: 20
    },
    scales: {
      y: {
        beginAtZero: true,
      }
    },
    plugins: {
      legend: {
        labels: {
          font: {
            size: 14,
            family: `"Prompt", sans-serif`
          }
        }
      }
    }
  }
});

const ctn = document.getElementById('do1Chart');

new Chart(ctn, {
  type: 'doughnut',
  data: {
    labels: ['ม.ค', 'ก.พ',],
    datasets: [{
      data: [1, 0.2],
      backgroundColor: 'rgba(208, 125, 217, 0.5)',
      borderColor: '#ce49e4',
      borderWidth: 5,
    }]
  },
  options: {
    layout: {
      padding: 20
    },
    scales: {
      y: {
        beginAtZero: true,
      }
    },
    plugins: {
      legend: {
        labels: {
          font: {
            size: 14,
            family: `"Prompt", sans-serif`
          }
        }
      }
    }
  }
});


const ct = document.getElementById('do2Chart');

new Chart(ct, {
  type: 'doughnut',
  data: {
    labels: ['ม.ค', 'ก.พ',],
    datasets: [{
      data: [1, 0.2],
      backgroundColor: 'rgba(222, 183, 108, 0.5)',
      borderColor: '#deb76c',
      borderWidth: 5,
    }]
  },
  options: {
    layout: {
      padding: 20
    },
    scales: {
      y: {
        beginAtZero: true,
      }
    },
    plugins: {
      legend: {
        labels: {
          font: {
            size: 14,
            family: `"Prompt", sans-serif`
          }
        }
      }
    }
  }
});

document.getElementById('maps').addEventListener('load', function(){
  // Will get called after embed element was loaded
  svgPanZoom(document.getElementById('maps'));
})